<qrcode [qrdata]="value" [width]="size" [errorCorrectionLevel]="'M'"></qrcode>
